import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category/love', hasDropdown: true },
  { label: '关于我们', path: '/about' },
];

const dropdownCategories = [
  { label: '爱情', path: '/category/love' },
  { label: '奇幻', path: '/category/fantasy' },
  { label: '动作', path: '/category/action' },
  { label: '悬疑', path: '/category/suspense' },
  { label: '搞笑', path: '/category/comedy' },
  { label: '剧情', path: '/category/drama' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-8">
        <div className="flex items-center gap-8">
          {navItems.map((item) =>
            item.hasDropdown ? (
              <div
                key={item.path}
                className="relative hidden md:block"
                onMouseEnter={() => setDropdownOpen(true)}
                onMouseLeave={() => setDropdownOpen(false)}
              >
                <Link
                  to={item.path}
                  className="flex items-center gap-1 text-sm font-medium text-foreground-800 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {item.label}
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </Link>
                {dropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 bg-background-50 rounded-lg py-2 min-w-[140px] border border-background-200">
                    {dropdownCategories.map((cat) => (
                      <Link
                        key={cat.path}
                        to={cat.path}
                        className="block px-4 py-2 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                      >
                        {cat.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={item.path}
                to={item.path}
                className="hidden md:block text-sm font-medium text-foreground-800 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            )
          )}
          <button
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-800 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-book-open-line text-background-50 text-sm"></i>
          </div>
          <span className="text-lg font-bold text-foreground-900 font-heading whitespace-nowrap">韩漫网</span>
        </Link>

        <div className="flex items-center gap-3">
          <button className="w-8 h-8 flex items-center justify-center cursor-pointer" aria-label="搜索">
            <i className="ri-search-line text-lg text-foreground-700 hover:text-primary-500 transition-colors"></i>
          </button>
          <button className="w-8 h-8 flex items-center justify-center cursor-pointer" aria-label="用户">
            <i className="ri-user-line text-lg text-foreground-700 hover:text-primary-500 transition-colors"></i>
          </button>
          <Link
            to="/category/love"
            className="hidden sm:inline-flex items-center gap-1 px-4 py-2 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap"
          >
            开始阅读
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          {navItems.map((item) =>
            item.hasDropdown ? (
              <div key={item.path}>
                <button
                  className="flex items-center gap-1 text-sm font-medium text-foreground-800 w-full cursor-pointer"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  {item.label}
                  <i className={`text-xs transition-transform ${dropdownOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
                </button>
                {dropdownOpen && (
                  <div className="mt-2 ml-4 flex flex-col gap-2">
                    {dropdownCategories.map((cat) => (
                      <Link
                        key={cat.path}
                        to={cat.path}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                      >
                        {cat.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={item.path}
                to={item.path}
                className="text-sm font-medium text-foreground-800 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            )
          )}
        </div>
      )}
    </nav>
  );
}